<template>
  <div>
    <h4>英文科</h4>
    <dl>
      <dt>文法統整班</dt>
      <dd>
        適合小六到國一學生視英文程度參加。針對英文文法做加強，一年課程結束後會直接延續為文法進階班。
      </dd>

      <dt>資優英文班</dt>
      <dd>
        適合公立、私立學校學生參加的英文課程，包含英文文法、聽力、閱讀等訓練，穩扎穩打將英文實力提升！考試前會針對各校不同範圍做段考複習。
      </dd>

      <dt>菁英英文班 （需經甄試入班）</dt>
      <dd>
        菁英英文班為資優英文班加深加廣課程，適合公立、私立學校學生參加，難度較深需經過甄試入班。考試前會針對各校不同範圍做段考複習。
      </dd>
    </dl>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
